import { render, staticRenderFns } from "./news_adeb.vue?vue&type=template&id=9dc26f64&scoped=true"
import script from "./news_adeb.vue?vue&type=script&lang=js"
export * from "./news_adeb.vue?vue&type=script&lang=js"
import style0 from "./news_adeb.vue?vue&type=style&index=0&id=9dc26f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc26f64",
  null
  
)

export default component.exports